import { api } from "@/lib/api-client";
import type { Order, OrdersHistoryParams, OrdersHistoryResponse } from "@/types";

function buildHistoryQuery(params: OrdersHistoryParams): string {
  const qs = new URLSearchParams();
  if (params.page) qs.set("page", String(params.page));
  if (params.limit) qs.set("limit", String(params.limit));
  if (params.search) qs.set("search", params.search);
  if (params.status?.length) {
    params.status.forEach((s) => qs.append("status", s));
  }
  if (params.type) qs.set("type", params.type);
  if (params.dateFrom) qs.set("dateFrom", params.dateFrom);
  if (params.dateTo) qs.set("dateTo", params.dateTo);
  if (params.minAmount != null) qs.set("minAmount", String(params.minAmount));
  if (params.maxAmount != null) qs.set("maxAmount", String(params.maxAmount));
  if (params.sortBy) qs.set("sortBy", params.sortBy);
  if (params.sortDirection) qs.set("sortDirection", params.sortDirection);
  if (params.storeUlid) qs.set("storeUlid", params.storeUlid);
  const q = qs.toString();
  return q ? `?${q}` : "";
}

export const orderService = {
  getOngoing(token?: string): Promise<Order[]> {
    return api.get<Order[]>("/orders/ongoing", { token });
  },

  getHistory(token?: string, params: OrdersHistoryParams = {}): Promise<OrdersHistoryResponse> {
    return api.get<OrdersHistoryResponse>(
      `/orders/history${buildHistoryQuery(params)}`,
      { token }
    );
  },

  getDetail(ulid: string, token?: string): Promise<Order> {
    return api.get<Order>(`/orders/${ulid}`, { token });
  },
};
